// extracted by mini-css-extract-plugin
export default {"avatarImage":"ParticipantAvatar_avatarImage__+F4jV"};